import "../CSS/courses.css"
import "../CSS/partners.css"
const Partners = () => {
    const partners = ["/Sony.png", "/Acer.png", "/Duolingo.png", "/Broadcom.png"]


    return (
        <div>
            <h3 class="partner-heading">Our Partners</h3>
            <div className="partner">
                {partners.map((img, index) => {

                    return (
                        <div className="partner-card">
                            <img src={img}></img>
                        </div>
                         
                    )
                })}
            </div>
        </div>
    )
}
export default Partners;